import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { BUTTON_COLORS, VARIANTS } from 'shared/constants';

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {string} props.title
 * @param {string} props.text
 * @param {string} props.cancelText
 * @param {string} props.confirmText
 * @param {Function} props.onCancel
 * @param {Function} props.onConfirm
 */
export default function CancelConfirm({
  open, title, text, cancelText, confirmText, onCancel, onConfirm,
}) {
  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onCancel}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: 'grey.500',
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>{text}</DialogContent>
      <DialogActions>
        <Button variant={VARIANTS.outlined} autoFocus onClick={onCancel}>{cancelText}</Button>
        <Button
          variant={VARIANTS.contained}
          color={BUTTON_COLORS.error}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
